// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ba0mHSZ4u88hdp5EParE{justify-content:space-between;align-items:center;margin-bottom:40px;display:flex}._sy_c9pRw2IeIiCOUiku{position:absolute;top:0;left:-48px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerWrap": `Ba0mHSZ4u88hdp5EParE`,
	"previousStepButton": `_sy_c9pRw2IeIiCOUiku`
};
export default ___CSS_LOADER_EXPORT___;
